// extracted by mini-css-extract-plugin
export default {"dividerContainer":"DividerComponent_dividerContainer__fhsv-","textContent":"DividerComponent_textContent__IT6WF","divider":"DividerComponent_divider__q7g2S"};